module.exports = __webpack_public_path__ + "media/images/es/how-works-icon-2-f7703b30febfaea4f36a53ca6b3cf2ce.png";